import { render, staticRenderFns } from "./ResultRanking.vue?vue&type=template&id=00eb2768&scoped=true&lang=pug&"
import script from "./ResultRanking.vue?vue&type=script&lang=js&"
export * from "./ResultRanking.vue?vue&type=script&lang=js&"
import style0 from "./ResultRanking.vue?vue&type=style&index=0&id=00eb2768&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00eb2768",
  null
  
)

export default component.exports